import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54f8d6c0&scoped=true&"
import script from "./index.vue?vue&type=script&setup=true&lang=js&"
export * from "./index.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=54f8d6c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8d6c0",
  null
  
)

export default component.exports